import PropTypes from 'prop-types';

export const Component = PropTypes.shape({
  based_on_status: PropTypes.string,
  components: PropTypes.array,
  id: PropTypes.string.isRequired,
  is_group_parent: PropTypes.bool,
  is_overridden: PropTypes.bool,
  is_third_party: PropTypes.bool,
  logo_url: PropTypes.string,
  name: PropTypes.string.isRequired,
  position: PropTypes.number,
  status: PropTypes.string.isRequired,
});

export const ComponentStatuses = PropTypes.shape({
  operational: PropTypes.shape({
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  degraded_performance: PropTypes.shape({
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  partial_outage: PropTypes.shape({
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  major_outage: PropTypes.shape({
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  under_maintenance: PropTypes.shape({
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/types.js